import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getDiscordModule } from './module';

export interface Props {}

const ModuleLoader: React.FC<Props> = () => {
  return <DynamicModuleLoader modules={[getDiscordModule()]} />;
};
ModuleLoader.displayName = 'ModuleLoader';

export default ModuleLoader;
